module.exports = __webpack_public_path__ + "static/media/home-02 copy.dd471ea5.png";